import { useDispatch } from 'react-redux';
import classnames from 'classnames';

import UserAvatar from 'components/userAvatar';
import { useCtxHistory } from 'hooks';
import { AuthService } from 'services';
import { importStatic } from 'utils';

import { openSignUpModal } from '../../../store/modals/actions';
import {
  POPUP_SURVEY_SOURCE,
  REPORT_SALARY_SURVEY_FROM_MATCHES,
} from '../../../utils/constant';

import classes from './index.module.css';

const Link = ({ href, title }) => (
  <li>
    <a className="d-flex align-items-center" href={href}>
      {title}
    </a>
  </li>
);

export const Avatar = ({
  setWrapperRef,
  avatar,
  desktopDevice,
  isCompanyUser,
  goToMatches,
  handleLogout,
  toggleMobileMenu,
  toggleProfileMenu,
  profileMenu,
}) => {
  const dispatch = useDispatch();
  const history = useCtxHistory();

  const getSalaryReportProfile = async () => {
    const response = await AuthService.getSalaryReportProfile();
    return response &&
    response.length > 0 &&
    response.filter((answer) => answer.name === 'titles').length &&
    response.filter((answer) => answer.name === 'locations').length; 
  }

  const startSurvey = async () => {
    const reportProfile = await getSalaryReportProfile();
    if(reportProfile){
      window.location.href = "/matches/salary/";
      return;
    }
    const query = {
      survey_step: 'step1',
      survey: REPORT_SALARY_SURVEY_FROM_MATCHES,
      src: POPUP_SURVEY_SOURCE.MATCHES_PAGE,
      skipQuestion: [8]
    };
    dispatch(openSignUpModal({
      ...query,
      popupType: 'career-callout-sign-up',
    }, true));
    history.pushQuery(query);
  };

  return (
  <div className={classes.container}>
    <div className="d-none d-lg-block" ref={setWrapperRef}>
      <div onClick={toggleProfileMenu} aria-expanded={profileMenu} aria-controls="loginInfoArea">
        <UserAvatar
          src={avatar || importStatic('/ui-router/images/default-user.png')}
          fallbackSrc={importStatic('/ui-router/images/default-user.png')}
          onError={(e) => {
            e.target.src = importStatic('/ui-router/images/default-user.png');
          }}
          isDesktop={desktopDevice}
        />
      </div>
      <div
        className={classnames(classes.dropdown, {
          [classes.show]: profileMenu,
        })}
        id="loginInfoArea"
      >
        <ul className="m-0 p-0">
          {!isCompanyUser && (
            <li className="d-flex align-items-center" onClick={goToMatches}>
              My Jobs
            </li>
          )}
          <Link href="/my-resume/" title="My Resume" />
          <li className="survey-button" onClick={startSurvey}>
            My Salary Report
          </li>
          <Link href="/dashboard/" title="My Career Insights" />
          <div className={classes.divider} />
          <Link href="/profile/" title="Profile" />
          <li className="g_id_signout d-flex align-items-center" onClick={handleLogout}>
            Log Out
          </li>
        </ul>
      </div>
    </div>
    <div className="d-block d-lg-none" onClick={toggleMobileMenu}>
      <UserAvatar
        src={avatar || importStatic('/ui-router/images/default-user.png')}
        fallbackSrc={importStatic('/ui-router/images/default-user.png')}
        isDesktop={desktopDevice}
      />
    </div>
  </div>
  )
};
